var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.PageTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onBackClick()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        {
                          staticClass: "editDetails",
                          attrs: { id: "editDetails" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c(
                                    "v-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        name: "locationId",
                                        id: "locationId",
                                        label: "text",
                                        filterable: false,
                                        options: _vm.locationArr,
                                        placeholder: "Select State"
                                      },
                                      on: {
                                        change: _vm.changedValue,
                                        input: function($event) {
                                          return _vm.changedValueLocation()
                                        },
                                        search: _vm.onSearchLocation
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "option",
                                          fn: function(option) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "d-center" },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(option.text) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "selected-option",
                                          fn: function(option) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selected d-center"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(option.text) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ]),
                                      model: {
                                        value: _vm.locationId,
                                        callback: function($$v) {
                                          _vm.locationId = $$v
                                        },
                                        expression: "locationId"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "no-options" }, [
                                        _vm._v(
                                          "\n                                                    Search State...\n                                                "
                                        )
                                      ])
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("font", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(_vm.locationError))
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      name: "roleId",
                                      id: "roleData",
                                      label: "text",
                                      searchable: false,
                                      filterable: false,
                                      options: _vm.roleArr,
                                      placeholder: "Select Role"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.changedValueRole()
                                      }
                                    },
                                    model: {
                                      value: _vm.roleId,
                                      callback: function($$v) {
                                        _vm.roleId = $$v
                                      },
                                      expression: "roleId"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("font", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(_vm.roleError))
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.title,
                                        expression: "title"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "title",
                                      placeholder: "Title"
                                    },
                                    domProps: { value: _vm.title },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.title = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("font", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(_vm.titleError))
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
                            },
                            [
                              [
                                _c(
                                  "div",
                                  { attrs: { id: "app" } },
                                  [
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _c("vue-dropzone", {
                                      ref: "dropzone",
                                      attrs: {
                                        id: "drop1",
                                        options: _vm.dropzoneOptions,
                                        destroyDropzone: false,
                                        headers: _vm.dropzoneOptions.headers,
                                        name: "file"
                                      },
                                      on: {
                                        "vdropzone-removed-file":
                                          _vm.removedSelectedFile,
                                        "vdropzone-success": _vm.vfileSuccess,
                                        "vdropzone-duplicate-file":
                                          _vm.vduplicateFile,
                                        "vdropzone-total-upload-progress":
                                          _vm.progressOfUloadImg
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("font", { staticClass: "text-danger" }, [
                                      _vm._v(_vm._s(_vm.imageError))
                                    ]),
                                    _vm._v(" "),
                                    _c("font", { staticClass: "text-danger" }, [
                                      _c("strong", {
                                        staticClass: "error text-danger",
                                        attrs: { id: "errorMsg2" }
                                      })
                                    ])
                                  ],
                                  1
                                )
                              ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "description" } },
                                    [_vm._v("Description")]
                                  ),
                                  _vm._v(" "),
                                  _c("tinymce", {
                                    ref: "tm",
                                    attrs: {
                                      plugins: [
                                        "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                                        "searchreplace wordcount visualblocks visualchars code fullscreen",
                                        "insertdatetime media nonbreaking save table contextmenu directionality",
                                        "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                                      ],
                                      id: "description",
                                      other_options: _vm.options
                                    },
                                    model: {
                                      value: _vm.description,
                                      callback: function($$v) {
                                        _vm.description = $$v
                                      },
                                      expression: "description"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("font", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(_vm.descriptionError))
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _c("div", { staticClass: " clearfix" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-6"
                            },
                            [
                              _c("div", { staticClass: "button-demo" }, [
                                _c("input", {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    id: "addBenifitBtn",
                                    type: "submit",
                                    value: "Save"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.addUpdatePoliciesForms()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    id: "addAndContinueBenifitBtn",
                                    type: "submit",
                                    value: "Save and Continue"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.addUpdatePoliciesForms(
                                        (_vm.flag = "Save and Continue")
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    id: "CancelBenifit",
                                    type: "submit",
                                    value: "Cancel"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.buttonCancleEdit()
                                    }
                                  }
                                })
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "viewDetails",
                          attrs: { id: "viewDetail" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
                            },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._m(6),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "form-control" },
                                  _vm._l(_vm.locationId, function(
                                    locations,
                                    index
                                  ) {
                                    return _c(
                                      "p",
                                      { staticStyle: { float: "left" } },
                                      [
                                        _vm._v(
                                          "\n                                                    " +
                                            _vm._s(locations.text) +
                                            "  \n                                                "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
                            },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._m(7),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-control" }, [
                                  _vm._v(_vm._s(_vm.roleDisplayName))
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
                            },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._m(8),
                                _vm._v(" "),
                                _c("span", { staticClass: "form-control" }, [
                                  _vm._v(_vm._s(_vm.title))
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
                            },
                            [
                              [
                                _c("div", { attrs: { id: "app" } }, [
                                  _vm._m(9),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src: _vm.imageDisplayWhileView,
                                      height: "200px",
                                      width: "200px"
                                    }
                                  })
                                ])
                              ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
                            },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "description" } }, [
                                  _vm._v("Description")
                                ]),
                                _vm._v(" "),
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.description)
                                  }
                                })
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        {
                          staticClass: "policiesFormsDocsDiv",
                          attrs: { id: "policiesFormsDocsDiv" }
                        },
                        [
                          _c("div", { attrs: { id: "myRadioGroup" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "buttonTitle" } },
                                      [_vm._v("Button Title")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.buttonTitle,
                                          expression: "buttonTitle"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "buttonTitle",
                                        placeholder: "Button Title"
                                      },
                                      domProps: { value: _vm.buttonTitle },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.buttonTitle = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("font", { staticClass: "text-danger" }, [
                                      _vm._v(_vm._s(_vm.buttonTitleError))
                                    ])
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(11),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "desc",
                                staticStyle: { display: "none" },
                                attrs: { id: "Cars2" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                  },
                                  [
                                    [
                                      _c(
                                        "div",
                                        { attrs: { id: "dropzone" } },
                                        [
                                          _c("vue-dropzone", {
                                            ref: "dropzoneDocFile",
                                            attrs: {
                                              id: "drop1",
                                              options:
                                                _vm.dropzoneOptionsDocFile,
                                              destroyDropzone: false,
                                              headers:
                                                _vm.dropzoneOptionsDocFile
                                                  .headers,
                                              name: "file"
                                            },
                                            on: {
                                              "vdropzone-removed-file":
                                                _vm.removedSelectedDocFile,
                                              "vdropzone-success":
                                                _vm.vDocfileSuccess,
                                              "vdropzone-total-upload-progress":
                                                _vm.progressOfUload
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(_vm.docUploadError)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "desc",
                                attrs: { div: "", id: "Cars3" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "buttonURL" } },
                                          [_vm._v("Button URL")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.buttonURL,
                                              expression: "buttonURL"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            id: "buttonURL",
                                            placeholder: "Button URL"
                                          },
                                          domProps: { value: _vm.buttonURL },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.buttonURL =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "font",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(_vm.buttonURLError))]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(12),
                          _vm._v(" "),
                          _c("div", { staticClass: " clearfix" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            },
                            [
                              _c("div", { staticClass: "button-demo" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      id: "savePoliciesFormsDocs",
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.saveUploadedDoc()
                                      }
                                    }
                                  },
                                  [_vm._v("Save")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      id: "cancleDocUpload",
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onCancleUpload()
                                      }
                                    }
                                  },
                                  [_vm._v("Cancel")]
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "listPoliciesFormsDocsDiv",
                          attrs: { id: "listPoliciesFormsDocsDiv" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "buttonTitle" } }, [
                                  _vm._v("Uploaded Doc List")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-line" }, [
                                  _c(
                                    "ul",
                                    [
                                      _c(
                                        "draggable",
                                        {
                                          staticClass: "drag-view",
                                          on: {
                                            change: function($event) {
                                              return _vm.changeButtonPosition()
                                            }
                                          },
                                          model: {
                                            value: _vm.policiesFormDocList,
                                            callback: function($$v) {
                                              _vm.policiesFormDocList = $$v
                                            },
                                            expression: "policiesFormDocList"
                                          }
                                        },
                                        [
                                          _vm._l(
                                            _vm.policiesFormDocList,
                                            function(text, index) {
                                              return [
                                                _c(
                                                  "li",
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "mb-1 btn btn-primary",
                                                        attrs: {
                                                          title: "Delete Doc",
                                                          id: "deleteDoc"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.deleteDoc(
                                                              text.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-trash",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    text.button_url != ""
                                                      ? [
                                                          text.button_type ==
                                                          "url"
                                                            ? [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      href:
                                                                        text.button_url,
                                                                      target:
                                                                        "_blank"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          text.button_title
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      href: "#",
                                                                      id:
                                                                        "id" +
                                                                        index
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.getSignedUrlPath(
                                                                          text.button_url
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          text.button_title
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                        ]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", [
        _vm._v(
          "\n                                    View/Update Details\n                                    "
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-primary pull-right",
            attrs: { id: "view", type: "button" }
          },
          [
            _c("i", {
              staticClass: "fa fa-eye",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary pull-right",
            attrs: { id: "edit", type: "button" }
          },
          [
            _c("i", {
              staticClass: "fa fa-pencil",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "locationId" } }, [
      _vm._v("State"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "roleData" } }, [
      _vm._v("Role"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "description" } }, [
      _vm._v("Title"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "drop1" } }, [
      _vm._v("Upload Image"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: " clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "locationId" } }, [
      _vm._v("State"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "roleData" } }, [
      _vm._v("Role"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "description" } }, [
      _vm._v("Title"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "drop1" } }, [
      _vm._v("Uploaded Image"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", [
        _vm._v(
          "\n                                    Upload Docs\n                                    "
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-primary pull-right",
            attrs: { id: "showDocListBtn", type: "button" }
          },
          [
            _c("i", {
              staticClass: "fa fa-eye",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary pull-right",
            attrs: { id: "addDocBtn", type: "button" }
          },
          [
            _c("i", {
              staticClass: "fa fa-plus",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6",
        staticStyle: { display: "none" }
      },
      [
        _c("span", { attrs: { id: "myForm" } }, [
          _c("label", [
            _c("input", {
              attrs: {
                id: "vodepUrl",
                type: "radio",
                name: "cars",
                value: "3",
                checked: "checked"
              }
            }),
            _vm._v("Enter URL")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: " clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertErrorDoc" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsgDoc" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cad57ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cad57ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/surveys/ViewUpdateSurveys.vue
// module id = null
// module chunks = 